import { render, staticRenderFns } from "./Protokoll.vue?vue&type=template&id=e5038f16&"
import script from "./Protokoll.vue?vue&type=script&lang=js&"
export * from "./Protokoll.vue?vue&type=script&lang=js&"
import style0 from "./Protokoll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports